(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collage-banner"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Set();
  const observers = new Map();
  const finish = () => {
    observers.forEach(observer => observer.disconnect());
    observers.clear();
    active.forEach(animation => animation.cancel());
    active.clear();
  };
  const init = (scope = document) => {
    if (motion.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
    scope.querySelectorAll('[data-mz-scroll-collage]').forEach(section => {
      if (section.dataset.mzMotionReady) return;
      section.dataset.mzMotionReady = 'true';
      const observer = new IntersectionObserver(entries => {
        let stagger = 0;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          if (motion.matches) return;
          const card = entry.target;
          const distance = window.innerWidth < 768 ? 28 : 56;
          const animation = card.animate([
            { opacity: 0, transform: 'translate3d(0,' + distance + 'px,0)' },
            { opacity: 1, transform: 'translate3d(0,0,0)' }
          ], {
            duration: card.classList.contains('collage-item-1') ? 1000 : 850,
            delay: Math.min(stagger++ * 100, 300),
            easing: 'cubic-bezier(.22,1,.36,1)',
            fill: 'backwards'
          });
          active.add(animation);
          animation.onfinish = () => active.delete(animation);
          animation.oncancel = () => active.delete(animation);
          card.addEventListener('focusin', () => animation.cancel(), { once: true });
        });
      }, { threshold: 0.08 });
      section.querySelectorAll('.collage-grid-item').forEach(card => observer.observe(card));
      observers.set(section, observer);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    observers.forEach((observer, section) => {
      if (event.target.contains(section)) { observer.disconnect(); observers.delete(section); }
    });
  });
  motion.addEventListener('change', event => { if (event.matches) finish(); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.trans = this.dataset.trans;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headersub = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      window.matchMedia('(max-width: 992px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.onScroll();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight ) {
      // if (scrollTop != 0) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom || scrollTop > this.header.offsetHeight ) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top || scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);










  
  document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.section-header');
  const headerWrapper = document.querySelector('.header-wrapper');
  let headerIsAlwaysSticky = headerWrapper && headerWrapper.dataset.stickyType === 'always' || headerWrapper.dataset.stickyType === 'reduce-logo-size';
  let headerBounds = {};
  let currentScrollTop = 0;
  // let preventReveal = false;
  // let isScrolling;

  const onScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (!header) return;
    if (!headerIsAlwaysSticky) {
      if (scrollTop > currentScrollTop && scrollTop > headerBounds.bottom || scrollTop > header.offsetHeight) {
        header.classList.add('not_sticky');
      } else if (scrollTop < currentScrollTop && scrollTop > headerBounds.bottom || scrollTop > header.offsetHeight) {
        header.classList.add('not_sticky');
      } else if (scrollTop <= headerBounds.top || scrollTop < header.offsetHeight) {
        header.classList.remove('not_sticky');
      }
    } 
    currentScrollTop = scrollTop;
  };
  window.addEventListener('scroll', onScroll, false);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mz-accessories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mz-accessory-filter')) {
  customElements.define('mz-accessory-filter', class extends HTMLElement {
    connectedCallback() {
      this.controls = Array.from(this.querySelectorAll('[data-filter]'));
      this.cards = Array.from(this.querySelectorAll('[data-category-group]'));
      this.status = this.querySelector('[role="status"]');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.controls.forEach(control => {
        control.setAttribute('role', 'button');
        control.addEventListener('click', event => {
          if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this.select(control.dataset.filter);
          if (window.location.hash !== control.hash) {
            window.history.pushState(window.history.state, '', control.hash);
          }
        }, options);
        control.addEventListener('keydown', event => {
          if (event.key === ' ') {
            event.preventDefault();
            control.click();
          }
        }, options);
      });
      this.onLocationChange = () => this.select(this.groupFromHash());
      window.addEventListener('hashchange', this.onLocationChange, options);
      window.addEventListener('popstate', this.onLocationChange, options);
      this.select(this.groupFromHash());
      if (this.cards.some(card => '#' + card.id === window.location.hash)) {
        this.scrollFrame = requestAnimationFrame(() => this.scrollIntoView({ block: 'start' }));
      }
    }
    disconnectedCallback() {
      this.events?.abort();
      cancelAnimationFrame(this.scrollFrame);
    }
    groupFromHash() {
      const card = this.cards.find(item => '#' + item.id === window.location.hash);
      return card ? card.dataset.categoryGroup : 'all';
    }
    select(group) {
      let count = 0;
      this.cards.forEach(card => {
        const visible = group === 'all' || card.dataset.categoryGroup === group;
        card.hidden = !visible;
        if (visible) count += 1;
      });
      this.controls.forEach(control => {
        control.setAttribute('aria-pressed', String(control.dataset.filter === group));
      });
      if (this.status) {
        this.status.textContent = this.dataset.countMessage.replace('__COUNT__', String(count));
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mz-carrier-selector"] && !Shopify.designMode) return;
  try {
    
function setupMobileZoneCarrier(){
  document.querySelectorAll('[data-mz-carrier]').forEach(function(root){
    if(root.dataset.ready) return;
    root.dataset.ready='true';
    var select=root.querySelector('[data-carrier-select]');
    var link=root.querySelector('[data-carrier-enquiry]');
    var status=root.querySelector('[data-carrier-status]');
    var note=status.textContent;
    var message=root.querySelector('[data-carrier-message]').content.textContent;
    select.addEventListener('change',function(){
      status.textContent=select.value ? message.replace('__CARRIER__',select.value) : note;
      link.href='mailto:support@mobilezonetexas.com?subject='+encodeURIComponent('iPhone carrier availability')+'&body='+encodeURIComponent('Hello Mobile Zone,\n\nI am interested in an iPhone.\nRequested carrier: '+(select.value||'Not selected')+'\nPreferred model: \n\nPlease confirm availability.\n');
    });
  });
}
setupMobileZoneCarrier();
document.addEventListener('shopify:section:load',setupMobileZoneCarrier);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mz-exchange"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const instances = new Map();
  let frame = 0;
  const updateScroll = () => {
    frame = 0;
    if (motion.matches || document.hidden) return;
    instances.forEach((state, section) => {
      if (!section.hasAttribute('data-visible') || section.hasAttribute('data-paused')) return;
      const rect = section.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, (innerHeight - rect.top) / (innerHeight + rect.height)));
      section.style.setProperty('--exchange-scroll', progress.toFixed(3));
    });
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(updateScroll); };
  const sync = () => {
    instances.forEach((state, section) => {
      section.toggleAttribute('data-hidden', document.hidden);
      state.toggle.hidden = motion.matches;
      if (motion.matches) state.animations.forEach(animation => animation.cancel());
    });
    schedule();
  };
  const init = (root = document) => root.querySelectorAll('[data-mz-exchange]').forEach(section => {
    if (instances.has(section)) return;
    const abort = new AbortController();
    const animations = [];
    const toggle = section.querySelector('[data-mz-exchange-toggle]');
    const reveal = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!motion.matches && !section.hasAttribute('data-paused') && !entry.target.contains(document.activeElement)) {
        animations.push(entry.target.animate([{opacity:.45,transform:'translateY(25px)'},{opacity:1,transform:'translateY(0)'}],{duration:750,easing:'cubic-bezier(.2,.75,.3,1)'}));
      }
      reveal.unobserve(entry.target);
    }), {threshold:.08});
    section.querySelectorAll('[data-mz-exchange-reveal]').forEach(item => reveal.observe(item));
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      section.toggleAttribute('data-visible', entry.isIntersecting);
      schedule();
    }));
    observer.observe(section);
    toggle.addEventListener('click', () => {
      const paused = section.toggleAttribute('data-paused');
      toggle.setAttribute('aria-pressed', String(paused));
      toggle.querySelector('span').textContent = paused ? toggle.dataset.play : toggle.dataset.pause;
      toggle.querySelector('path').setAttribute('d',paused?'M6 4l9 6-9 6Z':'M7 5v10M13 5v10');
      if (paused) animations.forEach(animation => animation.cancel());
      schedule();
    }, {signal:abort.signal});
    section.addEventListener('focusin', () => animations.forEach(animation => animation.cancel()), {signal:abort.signal});
    section.setAttribute('data-ready','');
    instances.set(section,{abort,animations,toggle,reveal,observer});
    sync();
  });
  init();
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule,{passive:true});
  document.addEventListener('visibilitychange',sync);
  motion.addEventListener('change',sync);
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => instances.forEach((state,section) => {
    if (!event.target.contains(section)) return;
    state.abort.abort(); state.observer.disconnect(); state.reveal.disconnect();
    state.animations.forEach(animation => animation.cancel()); instances.delete(section);
  }));
})();

  } catch(e) { console.error(e); }
})();
})();
